
const CommentTextarea = ({ changeHandler, textDisplay }) => {
  return <textarea className='comment-textarea' rows={11} onChange={changeHandler} value={textDisplay} />;
};
export default CommentTextarea;
